module.exports = __webpack_public_path__ + "static/media/phone_banner.5d207cad.svg";